import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; 
import './index.css';
import reportWebVitals from './reportWebVitals';

import HomePage from './Home/HomePage';
import PrivacyPolicy from './Home/PrivacyPolicy';   
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const RECAPTCHA_SITE_KEY = '6LeAWVQrAAAAAHpzq_sJOdBeZ5T6WsMLtNkj7x8n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{ async: true, defer: true }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/politica-privacidade"
            element={<PrivacyPolicy />}
          />
        </Routes>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  </React.StrictMode>
);

reportWebVitals();
